import { genericSort } from "../customSort/customSort";

export const vendorDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Company Name",
      accessor: "companyName",
      sortType:genericSort
    },
   
    {
      Header: "Contact Person",
      accessor: "contactPerson",
    },
    {
        Header: "email",
        accessor: "email",
    },
    {
      Header: "Pan Number",
      accessor: "panNumber",
    },
    {
      Header: "Bank Account",
      accessor: "bankAccount",
    },
    {
      Header: "Vendor",
      accessor: "isVendor",
    },
    {
      Header: "Consultant",
      accessor: "isConsultant",
    },
  
    {
      Header: "Action",
      accessor: "action",
    },
    
  ];